// Baked-in sample tournament for the isolated G-New Features sandbox. GG
// renders EVERY feature from this constant — it never reads a real tournament
// or any database tournament data. Match-play 4-ball, 2 flights, explicit
// pairings, per-player playing handicaps, a completed round of scores, and a
// calcutta block. The scores are generated once at module load by a pure,
// deterministic helper (no randomness, no DB) so the exported object is a
// stable constant every time.
const PARS = [4, 5, 3, 4, 4, 3, 5, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5, 4]
const STROKE_INDEX = [7, 3, 15, 1, 11, 17, 5, 9, 13, 8, 18, 2, 10, 6, 16, 12, 4, 14]

// Deterministic per-player gross for a two-player team. Lower playing handicaps
// score lower on average; a fixed hole/seed pattern adds spread. No Math.random
// so the constant is identical on every load.
function genScores([ph1 = 12, ph2 = 12], seed = 0) {
  const out = {}
  for (let h = 0; h < 18; h++) {
    const par = PARS[h]
    const v1 = ((h * 7 + seed) % 5) - 2
    const v2 = ((h * 3 + seed + 4) % 5) - 2
    const p1 = Math.max(2, par + Math.round(ph1 / 9) + v1 - 1)
    const p2 = Math.max(2, par + Math.round(ph2 / 9) + v2 - 1)
    out[h + 1] = { p1score: p1, p2score: p2, bestBall: Math.min(p1, p2) }
  }
  return out
}

const team = (name, players, startingHole, opponentId, playingHandicaps, seed) => ({
  // `handicaps` (per-player index array) enables the scramble net allowance;
  // for the sandbox we mirror the playing handicaps.
  info: { name, players, startingHole, opponentId, playingHandicaps, handicaps: playingHandicaps },
  scores: genScores(playingHandicaps, seed),
})

export const SAMPLE_TOURNAMENT = {
  info: {
    name: 'G- Sample Invitational',
    course: 'Pine Bluff Country Club',
    date: '2026-08-15',
    playStyle: 'match',
    format: '4-Ball Match Play',
    pars: PARS,
    strokeIndex: STROKE_INDEX,
  },
  flights: {
    championship: {
      info: { name: 'Championship Flight' },
      teams: {
        t1: team('Ratliff / Keese', ['Mark Ratliff', 'Cole Keese'], 1, 't2', [8, 14], 1),
        t2: team('Reed / Fox',       ['Tom Reed', 'Jim Fox'],       1, 't1', [5, 11], 2),
        t3: team('Lee / Park',       ['Ann Lee', 'Sam Park'],       3, 't4', [2, 20], 3),
        t4: team('Cole / Vega',      ['Ben Cole', 'Cara Vega'],     3, 't3', [12, 9], 4),
      },
    },
    first: {
      info: { name: 'First Flight' },
      teams: {
        t5: team('Diaz / Nolan', ['Rico Diaz', 'Pat Nolan'], 5, 't6', [16, 18], 5),
        t6: team('Ford / Shah',  ['Gus Ford', 'Amir Shah'],  5, 't5', [10, 7], 6),
      },
    },
  },
  teeTimes: {
    1: { championship: '8:00 AM', first: '8:20 AM' },
  },
  // Calcutta: bids per team (owner + winning amount) + payout structure.
  calcutta: {
    settings: { payoutStructure: [{ place: 1, pct: 50 }, { place: 2, pct: 30 }, { place: 3, pct: 20 }] },
    bids: {
      t1: { amount: 1200, owner: 'M. Ratliff' },
      t2: { amount: 1500, owner: 'D. Chen' },
      t3: { amount: 900, owner: 'L. Park' },
      t4: { amount: 1100, owner: 'B. Cole' },
      t5: { amount: 600, owner: 'R. Diaz' },
      t6: { amount: 800, owner: 'G. Ford' },
    },
  },
}
